"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeywordCountryExportResponseSchema = exports.KeywordExportResponseSchema = exports.KeywordExportSchema = exports.KeywordCountryExportSchema = exports.KeywordAppScoresListResponseSchema = exports.KeywordAppScoresQuerySchema = exports.KeywordAppRanksListResponseSchema = exports.KeywordAppRanksQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.KeywordAppRanksQuerySchema = (0, core_1.StrictObject)({
    to: core_1.TimestampSchema,
    from: core_1.TimestampSchema,
    keywords: typebox_1.Type.Array(ruby_1.KeywordSchema),
    country: core_1.CountrySchema,
    appId: core_1.IdSchema,
});
exports.KeywordAppRanksListResponseSchema = (0, core_1.StrictObject)({
    results: typebox_1.Type.Array(typebox_1.Type.Object({
        date: core_1.TimestampSchema,
        ranks: typebox_1.Type.Array(typebox_1.Type.Object({
            keyword: ruby_1.KeywordSchema,
            rank: typebox_1.Type.Integer(),
        })),
    })),
});
exports.KeywordAppScoresQuerySchema = (0, core_1.StrictObject)({
    to: core_1.TimestampSchema,
    from: core_1.TimestampSchema,
    keywords: typebox_1.Type.Array(ruby_1.KeywordSchema),
});
exports.KeywordAppScoresListResponseSchema = (0, core_1.StrictObject)({
    results: typebox_1.Type.Array(typebox_1.Type.Object({
        date: core_1.TimestampSchema,
        scores: typebox_1.Type.Array(typebox_1.Type.Object({
            keyword: ruby_1.KeywordSchema,
            score: typebox_1.Type.Integer(),
        })),
    })),
});
exports.KeywordCountryExportSchema = (0, core_1.StrictObject)({
    text: ruby_1.KeywordSchema,
    country: core_1.CountrySchema,
});
exports.KeywordExportSchema = (0, core_1.StrictObject)({
    keyword: ruby_1.KeywordSchema,
});
exports.KeywordExportResponseSchema = (0, core_1.StrictObject)({
    results: typebox_1.Type.Array(exports.KeywordExportSchema),
});
exports.KeywordCountryExportResponseSchema = (0, core_1.StrictObject)({
    results: typebox_1.Type.Array(exports.KeywordCountryExportSchema),
});
